var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceCeterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 13.273,
    height: 26.546,
    viewBox: "0 0 13.273 26.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings-cell",
    "data-name": "Icon material-settings-cell",
    d: "M10.106,26.546h2.212V24.334H10.106Zm4.424,0h2.212V24.334H14.53Zm4.424,0h2.212V24.334H18.955ZM20.061.011,11.212,0A2.219,2.219,0,0,0,9,2.212v17.7a2.219,2.219,0,0,0,2.212,2.212h8.849a2.219,2.219,0,0,0,2.212-2.212V2.212a2.209,2.209,0,0,0-2.212-2.2Zm.737,19.9H10.475V2.95H20.8Z",
    transform: "translate(-9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCeterActive);
export default __webpack_public_path__ + "static/media/service-ceter-active.e6b4f11309249aeeb7203e6df473e3a5.svg";
export { ForwardRef as ReactComponent };